import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import {
  ErrorMessage,
  Form,
  withFormik,
} from 'formik';

import { Form as SemanticForm } from 'semantic-ui-react';

import { captureException, InputFormField } from '@playbookux/playbook-web-core';
import {
  BottomContainer,
  Button,
  Container,
  Error,
  ErrorSubmit,
  Field,
  IconsContainer,
  Logo,
  Segment,
  SignInEmail,
  SSOIcons,
  Title,
} from './styles';

import { startWorkOSAuth } from '../../actions';

const SignInSSO = ({ handleSubmit, status }) => (
  <Container>
    <Logo src="/images/playbook-logo.png" alt="Playbook" />

    <Segment>
      <Title>
        Sign in with SSO (Google, Azure, Okta, ADFS and more)
      </Title>
      <IconsContainer>
        <SSOIcons src="/images/sso-icons.png" />
      </IconsContainer>

      <Form>
        <SemanticForm as="div">
          <Field
            component={InputFormField}
            labelFontSize="14px"
            labelText="Please enter your email address"
            placeholder="email@example.com"
            name="email"
          />
          <ErrorMessage component={Error} name="email" />

          <BottomContainer>
            <Button
              loading={status && status.isLoading}
              onClick={handleSubmit}
              type="submit"
            >
              Continue
            </Button>

            {status && status.error && <ErrorSubmit>{status.error}</ErrorSubmit>}
          </BottomContainer>
        </SemanticForm>
      </Form>
    </Segment>

    <SignInEmail to="/sign-in">
      Sign in with email
    </SignInEmail>
  </Container>
);

SignInSSO.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
};

SignInSSO.defaultProps = {
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  startWorkOSAuth,
}, dispatch);

export default compose(
  connect(null, mapDispatchToProps),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: () => ({
      email: '',
    }),
    handleSubmit: async (values, { props, setStatus }) => {
      setStatus({
        error: null,
        isLoading: true,
      });

      try {
        const { email } = values;

        const url = await props.startWorkOSAuth(email);
        window.location.href = url;
      } catch (err) {
        const error = (err && err.code && err.message)
          ? err.message
          : 'Error while signing in';

        captureException('SIGN_IN_SSO_HANDLE_SUBMIT_FAILED', err);

        setStatus({
          error,
          isLoading: false,
        });
      }
    },
  }),
)(SignInSSO);
